import(/* webpackMode: "eager" */ "/Users/bpico/Development/nuvation/ibtrozi.com/apps/full-promo/src/app/about-ibtrozi/page.js");
